import * as React from 'react';
import {AuthContext} from '../providers/AuthProvider';

export function useAuthContext() {
  return React.useContext(AuthContext);
}
